import { ApiError } from './api-error';

export const RECOVERABLE_PAYMENT_ERROR_CODES = [
    'PAYMENT_PROVIDER_NOT_CONFIGURED',
    'PAYMENT_SESSION_CREATION_FAILED',
    'PAYMENT_METHOD_UPDATE_FAILED',
    'RATE_BUNDLE_HAS_NO_PAYMENT_CHOICES'
] as const;

export const isRecoverablePaymentError = (error: ApiError) =>
    error.errorCodes.some((code) =>
        RECOVERABLE_PAYMENT_ERROR_CODES.includes(
            code as (typeof RECOVERABLE_PAYMENT_ERROR_CODES)[number]
        )
    );
